// Zentrale API-Konfiguration
// Im Dev-Modus (npm run start) werden relative Pfade genutzt,
// die vom Vite-Proxy an die echten Server weitergeleitet werden.
// Im Produktions-Build werden die absoluten URLs verwendet.

const isProd = true;

// --- GeoServer ---
export const GEOSERVER_BASE_URL = isProd
  ? "https://gis.treeclimatedb.de/geoserver/"
  : "/geoserver/";

export const GEOSERVER_WORKSPACE = "treeclimatedb";
export const GEOSERVER_OWS_URL = `${GEOSERVER_BASE_URL}ows`;
export const GEOSERVER_WFS_URL = `${GEOSERVER_BASE_URL}wfs`;
export const GEOSERVER_WMS_URL = isProd
  ? `https://gis.treeclimatedb.de/geoserver/${GEOSERVER_WORKSPACE}/wms`
  : `/geoserver/${GEOSERVER_WORKSPACE}/wms`;

// --- Sonstige Backend-Endpunkte ---
export const DUMP_URL = isProd
  ? "https://www.treeclimatedb.de/libs/getDBDump.php"
  : "/libs/getDBDump.php";

export const STATISTICS_URL = isProd
  ? "https://old.treeclimatedb.de/importScript/getTreeclimateStatistics.php"
  : "/importScript/getTreeclimateStatistics.php";

// --- Baumberater: externe APIs ---
export const OVERPASS_API_URL = isProd
  ? "https://overpass-api.de/api/interpreter"
  : "/overpass/api/interpreter";

export const METEO_ARCHIVE_BASE_URL = isProd
  ? "https://archive-api.open-meteo.com"
  : "/meteo-archive";

export const METEO_CLIMATE_BASE_URL = isProd
  ? "https://climate-api.open-meteo.com"
  : "/meteo-climate";

export const SOILGRIDS_BASE_URL = isProd
  ? "https://rest.isric.org"
  : "/soilgrids";
